"use client";

import React from "react";
import { Button } from "./Button";

interface PageHeaderProps {
  title: string | React.ReactNode;
  id?: string;
  /** Shown in light grey on the same line as the ID, after a separator. */
  subtitle?: string | React.ReactNode;
  buttonTitle?: string | React.ReactNode;
  onButtonPress?: () => void;
  /** Extra elements rendered to the left of the primary button. */
  actions?: React.ReactNode;
}

export function PageHeader({
  title,
  id,
  subtitle,
  buttonTitle,
  onButtonPress,
  actions,
}: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-5">
      <div>
        <h1>{title}</h1>
        {(id || subtitle) && (
          <p className="text-[10px] md:text-sm text-gray-400">
            {id && <>ID: {id}</>}
            {id && subtitle && " · "}
            {subtitle}
          </p>
        )}
      </div>
      <div className="flex items-center flex-col md:flex-row gap-2">
        {actions}
        {buttonTitle && onButtonPress && (
          <Button onClick={onButtonPress}>{buttonTitle}</Button>
        )}
      </div>
    </div>
  );
}
